"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusToUIKeyBase = exports.usePunchStatusModal = void 0;
const luxon_1 = require("luxon");
const utils_1 = require("../../../../utils");
const PunchCorrectionStatusTypes_1 = require("../../../../components/PunchCorrectionStatus/PunchCorrectionStatusTypes");
const react_i18next_1 = require("react-i18next");
function usePunchStatusModal({ dateTime, initialDateTime, militaryTime, status, reason, type, renderIconContainer, statusToUIKey, isCardLayout }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dateTimeObj = luxon_1.DateTime.fromISO(dateTime);
    const timeString = (0, utils_1.getTimeString)(dateTimeObj, militaryTime);
    const dateString = dateTimeObj.toLocaleString(luxon_1.DateTime.DATE_FULL);
    let initialTimeString, initialDateString;
    if (initialDateTime) {
        const initialDateTimeObj = luxon_1.DateTime.fromISO(initialDateTime);
        initialTimeString = (0, utils_1.getTimeString)(initialDateTimeObj, militaryTime);
        initialDateString = initialDateTimeObj.toLocaleString(luxon_1.DateTime.DATE_FULL);
    }
    const typeLocaleMapping = {
        [PunchCorrectionStatusTypes_1.PunchCorrType.DELETE_PUNCH]: t('time_and_attendance_PunchCorrectionType_DeletedPunch'),
        [PunchCorrectionStatusTypes_1.PunchCorrType.MISSED_PUNCH]: t('time_and_attendance_PunchCorrectionType_MissedPunch'),
        [PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH]: t('time_and_attendance_PunchCorrectionType_EditedPunch'),
        [PunchCorrectionStatusTypes_1.PunchCorrType.A_TO_Z_CLOCK_PUNCH]: t('time_and_attendance_PunchCorrectionType_AtoZClock')
    };
    const { icon, titleKey, detailKey, detailOptionsLowerCase } = getStatusMapping(status, reason, type, renderIconContainer, statusToUIKey, isCardLayout);
    const localedType = typeLocaleMapping[type] || type;
    return {
        icon,
        titleKey,
        detailKey,
        detailOptionsLowerCase,
        timeString,
        dateString,
        initialTimeString,
        initialDateString,
        localedType
    };
}
exports.usePunchStatusModal = usePunchStatusModal;
exports.statusToUIKeyBase = {
    success: {
        detailKey: 'time_and_attendance_PunchStatusModal_Success',
        titleKey: 'time_and_attendance_PunchStatusModal_SuccessTitle',
        detailOptionsLowerCase: false
    },
    further_review: {
        detailKey: 'time_and_attendance_PunchStatusModal_FurtherReview',
        titleKey: 'time_and_attendance_PunchStatusModal_FurtherReviewTitle',
        detailOptionsLowerCase: true
    },
    request_review: {
        detailKey: 'time_and_attendance_PunchStatusModal_RequestReview',
        titleKey: 'time_and_attendance_PunchStatusModal_RequestReviewTitle',
        detailOptionsLowerCase: true
    },
    under_review: {
        detailKey: 'time_and_attendance_PunchStatusModal_UnderReview',
        titleKey: 'time_and_attendance_PunchStatusModal_UnderReviewTitle',
        detailOptionsLowerCase: true
    },
    requested_approval: {
        detailKey: 'time_and_attendance_PunchStatusModal_RequestedApproval',
        titleKey: 'time_and_attendance_PunchStatusModal_RequestedApprovalTitle',
        detailOptionsLowerCase: true
    },
    approval_accepted: {
        detailKey: 'time_and_attendance_PunchStatusModal_RequestApproved',
        titleKey: 'time_and_attendance_PunchStatusModal_RequestApprovedTitle',
        detailOptionsLowerCase: true
    },
    approval_rejected: {
        detailKey: 'time_and_attendance_PunchStatusModal_RequestRejected',
        titleKey: 'time_and_attendance_PunchStatusModal_RequestRejectedTitle',
        detailOptionsLowerCase: true
    },
    processing: {
        detailKey: 'time_and_attendance_PunchStatusModal_Processing',
        titleKey: 'time_and_attendance_PunchStatusModal_ProcessingTitle',
        detailOptionsLowerCase: true
    },
    system_error: {
        detailKey: 'time_and_attendance_PunchStatusModal_SystemError',
        titleKey: 'time_and_attendance_PunchStatusModal_SystemErrorTitle',
        detailOptionsLowerCase: true
    },
    not_accepted: {
        detailKey: 'time_and_attendance_PunchStatusModal_NoSupportData',
        titleKey: 'time_and_attendance_PunchStatusModal_NotAcceptedTitle',
        detailOptionsLowerCase: true
    }
};
const getStatusMapping = (status, reason, type, renderIconContainer, statusToUIKey, isCardLayout) => {
    let statusObj = null;
    switch (status) {
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.COMPLETED_SUCCESSFULLY:
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.SUBMITTED_SUCCESSFULLY:
            statusObj = statusToUIKey.success;
            break;
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.ELIGIBLE_FOR_APPROVAL:
            statusObj = statusToUIKey.request_review;
            break;
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.APPROVAL_REQUESTED:
            statusObj = statusToUIKey.requested_approval;
            break;
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.APPROVAL_ACCEPTED:
            statusObj = statusToUIKey.approval_accepted;
            break;
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.APPROVAL_REJECTED:
            statusObj = statusToUIKey.approval_rejected;
            break;
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.IN_PROGRESS:
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.PENDING:
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.FAILED_PENDING_RETRY:
            statusObj = statusToUIKey.under_review;
            if (type === PunchCorrectionStatusTypes_1.PunchCorrType.MISSED_PUNCH ||
                type === PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH ||
                type == PunchCorrectionStatusTypes_1.PunchCorrType.A_TO_Z_CLOCK_PUNCH) {
                if ((status === PunchCorrectionStatusTypes_1.PunchCorrStatus.IN_PROGRESS ||
                    status === PunchCorrectionStatusTypes_1.PunchCorrStatus.PENDING) &&
                    reason === PunchCorrectionStatusTypes_1.PunchCorrReason.PENDING_REVIEW) {
                    statusObj = statusToUIKey.further_review;
                }
                if (status === PunchCorrectionStatusTypes_1.PunchCorrStatus.IN_PROGRESS && !reason) {
                    statusObj = statusToUIKey.processing;
                }
            }
            break;
        case PunchCorrectionStatusTypes_1.PunchCorrStatus.FAILED:
            statusObj = statusToUIKey.system_error;
            if (type === PunchCorrectionStatusTypes_1.PunchCorrType.MISSED_PUNCH ||
                type === PunchCorrectionStatusTypes_1.PunchCorrType.EDIT_PUNCH ||
                type == PunchCorrectionStatusTypes_1.PunchCorrType.A_TO_Z_CLOCK_PUNCH) {
                if (reason === PunchCorrectionStatusTypes_1.PunchCorrReason.REJECTED) {
                    statusObj = statusToUIKey.not_accepted;
                }
                if (reason === PunchCorrectionStatusTypes_1.PunchCorrReason.DUPLICATE) {
                    statusObj = statusToUIKey.under_review;
                }
            }
            break;
        default:
            statusObj = statusToUIKey.system_error;
    }
    return Object.assign(Object.assign({}, statusObj), { icon: renderIconContainer(statusObj.iconComp, isCardLayout) });
};
